import { CURRENT_PRODUCT_MODE, DEFAULT_SORT } from '@utils/constants';
import { metricKeys } from '@pulse/metrics';
import { WIDGET_TYPES, DEFAULT_FILTER } from '@src/utils/kpi';
import moment from 'moment';
import { getDateShortcuts } from '@src/utils/tz';

export const DEFAULT_DIMENSIONS = {
  EI: ['OBJECT_NAME', 'm3.dv.n', 'c3.video.isLive'],
  AI: ['OBJECT_NAME', 'c3.ad.position', 'c3.ad.technology'],
  APP: ['device_name', 'app_id', 'application_version', 'geo_city'],
};

export const initialFilter = {
  appliedFilters: [DEFAULT_FILTER],
  sort: DEFAULT_SORT,
  breadcrumb: [DEFAULT_FILTER],
};

const appWidgets = [
  {
    type: WIDGET_TYPES.dimensionTable,
    config: {
      dimensions: DEFAULT_DIMENSIONS[CURRENT_PRODUCT_MODE],
      unit: '%',
    },
  },
];

export const eiWidgets = [
  {
    type: WIDGET_TYPES.audienceMetrics,
    config: {},
  },
  {
    type: WIDGET_TYPES.spi,
    config: {
      thresholdType: 'conviva-good',
      thresholdConfig: {},
    },
  },
  {
    type: WIDGET_TYPES.subOpportunities,
    config: {},
  },
  {
    type: WIDGET_TYPES.dimensionTable,
    config: {
      dimensions: DEFAULT_DIMENSIONS[CURRENT_PRODUCT_MODE],
      unit: '%',
    },
  },
];

export const initialWidgets =
  {
    EI: eiWidgets,
    APP: appWidgets,
  }[CURRENT_PRODUCT_MODE] || [];

export const initialMetric = {
  EI: metricKeys.StreamingPerformanceIndex,
  APP: metricKeys.UserActiveTime,
}[CURRENT_PRODUCT_MODE];

const shortcuts = getDateShortcuts();
const [shortcut, interval] = shortcuts[0];

export const initialInterval = {
  from: moment(interval[0]).format(),
  to: moment(interval[1]).format(),
  shortcut,
};
